import type { RumPublicApi } from '@datadog/browser-rum-core';

const generateDatadogRumWrapper = (): Omit<RumPublicApi, 'init'> => {
  const methods: Array<keyof Omit<RumPublicApi, 'init'>> = [
    'addAction',
    'addDurationVital',
    'addError',
    'addFeatureFlagEvaluation',
    'addTiming',
    'clearGlobalContext',
    'clearUser',
    'getGlobalContext',
    'getInitConfiguration',
    'getInternalContext',
    'getSessionReplayLink',
    'getUser',
    // 'init', // we don't want to expose the init method
    'removeGlobalContextProperty',
    'removeUserProperty',
    'setGlobalContext',
    'setGlobalContextProperty',
    'setTrackingConsent',
    'setUser',
    'setUserProperty',
    'setViewContext',
    'setViewContextProperty',
    'startDurationVital',
    'startSessionReplayRecording',
    'stopDurationVital',
    'stopSession',
    'stopSessionReplayRecording',
  ];
  return methods.reduce((acc, method) => {
    (acc[method] as any) = (...args: any[]) => {
      if (window.DD_RUM && typeof window.DD_RUM[method] === 'function') {
        try {
          (window.DD_RUM[method] as any)(...args);
        } catch (error) {
          console.error(`Failed to execute window.DD_RUM.${method}:`, error);
        }
      } else {
        console.warn(`window.DD_RUM.${method} is not available`);
      }
    };
    return acc;
  }, {} as Omit<RumPublicApi, 'init'>);
};

const datadogRum = generateDatadogRumWrapper();

export { datadogRum };
